//存储
export const setStorage = (key, data) => {
  let val = data;
  let storage = {
    type: "string",
    value: val
  };
  if (typeof val == "object") {
    val = JSON.stringify(val);
    storage = {
      type: "object",
      value: val
    };
  }
  // console.log('val',val)
  try {
    uni.setStorageSync(key, JSON.stringify(storage));
  } catch (e) {
    console.log(e);
  }
};
//获取数据
export const getStorage = key => {
  try {
    var storage = uni.getStorageSync(key);
    if (storage) {
      storage = JSON.parse(storage);
      if (storage.type == "object") {
        return JSON.parse(storage.value);
      } else {
        return storage.value;
      }
    } else {
      return "";
    }
  } catch (e) {
    console.log(e);
  }
};

//删除记录
export const removeStorage = key => {
  try {
    uni.removeStorageSync(key);
  } catch (e) {
    // error
  }
};
//简单时间格式化
//使用方法 供新手参考 :
// 在vue文件中 import { dateFormat } from '@/js_sdk/common.js'
//let date = new Date();
// dateFormat("YYYY-mm-dd HH:MM:SS",date)
export const dateFormat = (fmt, date) => {
	let ret;
	const opt = {
		"Y+": date.getFullYear().toString(), // 年
		"m+": (date.getMonth() + 1).toString(), // 月
		"d+": date.getDate().toString(), // 日
		"H+": date.getHours().toString(), // 时
		"M+": date.getMinutes().toString(), // 分
		"S+": date.getSeconds().toString() // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	};
	for (let k in opt) {
		ret = new RegExp("(" + k + ")").exec(fmt);
		if (ret) {
			fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
		};
	};
	return fmt;
}
//深拷贝
export const deepClone = obj => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  const clonedObj = Array.isArray(obj) ? [] : {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      clonedObj[key] = deepClone(obj[key]);
    }
  }

  return clonedObj;
};

export const timestampToDate = timestamp => {
  // 创建一个新的Date对象，以毫秒为单位
  var date = new Date(timestamp);

  // 获取年份
  var year = date.getFullYear();

  // 获取月份（注意JavaScript中的月份是从0开始的，所以需要加1）
  var month = date.getMonth() + 1;

  // 获取日期
  var day = date.getDate();

  // 格式化日期为两位数，如果是个位数的话，前面补0
  month = (month < 10 ? "0" : "") + month;
  day = (day < 10 ? "0" : "") + day;

  // 返回格式化的日期字符串
  return year + "-" + month + "-" + day;
};

//计算两个日期之间的天数
export const diffBetweenDates = (date1, date2) => {
  var startDate = new Date(date1);
  var endDate = new Date(date2);

  var timeDiff = endDate - startDate; // 得到的是毫秒数
  var daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  return daysDiff + 1;
};

//计算指定日期后若干天的日期
export const getFutureDate = (start, days) => {
  let date = new Date(start);
  date.setDate(date.getDate() + days);
  return formatDate(date);
};
export function formatDate(date) {
  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);
  var hours = ("0" + date.getHours()).slice(-2);
  var minutes = ("0" + date.getMinutes()).slice(-2);
  var seconds = ("0" + date.getSeconds()).slice(-2);

  return year + "-" + month + "-" + day; // + " " + hours + ":" + minutes + ":" + seconds;
}

export const getNowDateTime = type => {
  let dateObject = new Date();

  let date = ("0" + dateObject.getDate()).slice(-2);
  let month = ("0" + (dateObject.getMonth() + 1)).slice(-2);
  let year = dateObject.getFullYear();

  let hours = dateObject.getHours();
  let minutes = dateObject.getMinutes();
  let seconds = dateObject.getSeconds();
  if (type == "date") {
    return `${year}/${month}/${date}`;
  } else {
    return `${year}/${month}/${date} ${hours}:${minutes}:${seconds}`;
  }
};

export const calculateHours = (startDate, endDate) => {
  // 创建 Date 对象
  var start = new Date(startDate);
  var end = new Date(endDate);

  // 计算时间差（以毫秒为单位）
  var timeDiff = end - start;

  // 将时间差转换为小时数
  var hours = timeDiff / (1000 * 60 * 60); // 1000ms = 1s, 60s = 1min, 60min = 1h

  return hours;
};
/**
 * 简易防抖函数
 * @param {Function} func -防抖目标函数
 * @param {Number} wait - 防抖时间间隔
 * @param {Boolean} immediate - 是否立即执行
 */
export const debounce = (func, wait, immediate) => {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...params) {
    context = this
    args = params
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js